export default "__VITE_ASSET__CF6$L1P5__";